export default "__VITE_PUBLIC_ASSET__8f421903__"